export const normalizeOrganizationSlug = (slug: string): string => {
  return slug
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const generateSlugFromName = (name: string): string => {
  return normalizeOrganizationSlug(name);
};

